import React from 'react';
import { ToastContainer } from 'react-toastify';

const contextClass = {
  success: "bg-toast-success text-toast-success-text",
  error: "bg-toast-error text-toast-error-text",
  info: "bg-toast-info text-toast-info-text",
  warning: "bg-toast-warning text-toast-warning-text",
  default: "bg-indigo-600",
  dark: "bg-white-600 font-gray-300",
};

export const NotificationContainer = () => {
  return (
    <ToastContainer
      toastClassName={({ type }) => contextClass[type || "default"] +
        " relative flex p-5 rounded justify-between overflow-hidden cursor-pointer text-sm"
      }
      closeButton={false}
    />
  )
}
